import settings from "../utils/settings";
import SFError from "../models/SfError";
import { useDataProvider } from "ra-core";
const useEditPotential = () => {
  const dataprovider = useDataProvider();
  const editPotential = async ({ id, ...rest }) => {
    const { realmId, branchId, lang } = settings();

    try {
      const result = await dataprovider.update("potentials", {
        data: {
          id: id,
          locale: lang,
          realm_id: realmId,
          branch_id: branchId,
          __v: 0,
          ...rest,
        },
      });

      return result;
      /*
      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/potentials/${id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            locale: lang,
            realm_id: realmId,
            branch_id: branchId,
            __v: 0,
            ...rest,
          }),
        }
      );

      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: createNiceErrorMessage(jsonResult.message),
        });

        return error.json();
      }
      const jsonResult = await result.json();
      return jsonResult;
      */
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return sfError.json();
    }
  };
  return { editPotential };
};

export default useEditPotential;
